import { useState, useEffect, ReactElement } from "react";
import styles from "./OfferClaimPopup.module.css";

type OfferClaimPopup = ({
    nOffersClaimed,
    tTimePeriod,
}: {
    nOffersClaimed: number | undefined;
    tTimePeriod: number | undefined;
}) => ReactElement | null;

export const OfferClaimPopup: OfferClaimPopup = ({
    nOffersClaimed,
    tTimePeriod,
}) => {
    const fadeInDelay = 1500;
    const fadeOutDelay = 3500 + fadeInDelay;

    const [isVisible, setIsVisible] = useState(false);
    const [animationClass, setAnimationClass] = useState("");

    useEffect(() => {
        const fadeInTimer = setTimeout(() => {
            setIsVisible(true);
        }, fadeInDelay);

        const fadeOutTimer = setTimeout(() => {
            setIsVisible(false);
        }, fadeOutDelay);

        return () => {
            clearTimeout(fadeInTimer);
            clearTimeout(fadeOutTimer);
        };
        // disable lint check because we are using this effect to set the timeout only on component
        // load - https://stackoverflow.com/a/53090848/498463
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isVisible) {
            setAnimationClass(styles.fadeIn);
        } else if (animationClass) {
            setAnimationClass(styles.fadeOut);
        }
    }, [animationClass, isVisible]);

    const fadeOut = () => {
        setIsVisible(false);
    };

    if (nOffersClaimed === undefined || tTimePeriod === undefined) {
        return null;
    }

    return (
        <div className={styles.popupContainer}>
            <div
                className={[styles.popup, animationClass].join(" ")}
                onClick={fadeOut}
            >
                <span className={styles.fireLogo}>&#128293;</span>
                <div className={styles.textWrapper}>
                    <span className={styles.offersClaimedText}>
                        {`${nOffersClaimed} offers claimed`}
                    </span>
                    &nbsp;
                    <span>{`in the last ${tTimePeriod} hours`}</span>
                </div>
            </div>
        </div>
    );
};
